import { IsNotEmpty, IsString, MaxLength, IsOptional, IsArray, MinLength } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ErrorTypeEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsOptional()
    @IsString()
    @MaxLength(3000)
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    products: Array<string>;

}
